module.exports = __webpack_public_path__ + "img/pg_card.f21fc948.png";